import React from "react";
import { Skeleton as ChakraSkeleton, SkeletonCircle as ChakraSkeletonCircle, SkeletonText as ChakraSkeletonText, } from "@chakra-ui/react";
/**
 * Skeleton is used to display the loading state of some components
 */
export const Skeleton = (props) => {
    return React.createElement(ChakraSkeleton, Object.assign({}, props));
};
Skeleton.displayName = "Skeleton";
export const SkeletonCircle = (props) => {
    return React.createElement(ChakraSkeletonCircle, Object.assign({}, props));
};
SkeletonCircle.displayName = "SkeletonCircle";
export const SkeletonText = (props) => {
    return React.createElement(ChakraSkeletonText, Object.assign({}, props));
};
SkeletonText.displayName = "SkeletonText";
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map